// extracted by mini-css-extract-plugin
export default {"numberHighlight":"VerifyNumber_numberHighlight__rxbWc"};